<dashboard-dialog-frame class="acc-team-dialog" [header]="headerName()" [actions]="actions" [dialogRef]="dialogRef">

	@if(dialogDataService.dialogData()){
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<acc-team-details-part></acc-team-details-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Mentors">
			<ng-template kendoTabContent>
				<acc-team-mentors-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></acc-team-mentors-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Ventures">
			<ng-template kendoTabContent>
				<acc-team-ventures-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></acc-team-ventures-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Overlapping Meetings">
			<ng-template kendoTabContent>
				<acc-team-overlapping-meetings-part></acc-team-overlapping-meetings-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>
	}
</dashboard-dialog-frame>